import { createSlice } from "@reduxjs/toolkit";

const cabinetSlice = createSlice({
  name: "cabinets",
  initialState: {
    isFetching: false,
    cabinets: [],
    error: []
  },
  reducers: {
    statusCabinetStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusCabinetSuccess: (state, action) => {
      state.isFetching = false
      state.cabinets = action.payload
      state.error = []
    },
    statusCabinetFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})


export const { 
  statusCabinetStart,
  statusCabinetSuccess,
  statusCabinetFailure 
} = cabinetSlice.actions

export default cabinetSlice.reducer